import React, { Fragment } from 'react'

import BkFlowEnhancementsCardDescription from '../elements/BkFlowEnhancementsCardDescription'
import BkFlowRoomEnhancementButton from '../BkFlowRoomEnhancementButton'

import yn from 'yn'

import rightArrow from '../../../assets/icons/arrow-right-medium.svg'

if (process.env.REACT_APP_COMPONENT_ENHANCEMENTS_CARD_LAYOUT === 'default') {
  require('../../../styles/css/components/enhancements/layouts/bk-flow-enhancements-card-default.css')
}

const BkFlowEnhancementsCardDefault = props => {
  const {
    activeRoom,
    currentEnhancementKey,
    enhancementCardType,
    enhancementImageSrc,
    enhancementKey,
    enhancementPrice,
    handleToggleServiceDescription,
    hotelLabels,
    isEnhancementSelected,
    keyedDetails,
    roomGroupKey,
    serviceDescriptionExpanded
  } = props

  return (
    <div
      className={isEnhancementSelected ? 'bk-flow-enhancements__card card-default active' : 'bk-flow-enhancements__card card-default inactive' }
      key={enhancementCardType[enhancementKey].serviceInventoryCode + '-' + enhancementKey}
    >
      { yn(process.env.REACT_APP_COMPONENT_ENABLE_ENHANCEMENTS_IMAGE) &&
        <div
          className="bk-flow-enhancements__card-image u-bg-image"
          style={{backgroundImage: 'url(' + enhancementImageSrc + ')'}}
        >
          <img
            className="u-element-hidden"
            src={ enhancementImageSrc }
            alt="Coming Soon"
          />
        </div>
      }

      <div className="bk-flow-enhancements__card-data">
        { keyedDetails.title ?
          <h4>{ keyedDetails.title.text }</h4>
        :
          <h4>{ hotelLabels.enhancement ? hotelLabels.enhancement : 'Enhancement'} : { enhancementCardType[enhancementKey].serviceInventoryCode }</h4>
        }

        { enhancementPrice &&
          <Fragment>
            <p className="bk-flow-enhancements__card-price u-font-bold">
              { enhancementPrice }
            </p>
            <p>
              {enhancementCardType[enhancementKey].servicePricingType}
            </p>
          </Fragment>
        }

        { keyedDetails.description &&
          keyedDetails.description.text &&
          <BkFlowEnhancementsCardDescription
            hotelLabels={hotelLabels}
            serviceDescription={keyedDetails.description.text}
            serviceDescriptionExpanded={serviceDescriptionExpanded}
            limitChars={0}
            serviceDescriptionEvent={() => handleToggleServiceDescription()}
          />
        }
      </div>
      <div className="bk-flow-enhancements__card-btn-group">
        <button className='btn btn-text-only' onClick={() => handleToggleServiceDescription()}>
          Details 
          <img
            className="arrow"
            src={rightArrow}
            alt='arrow pointing right'
          />
        </button>  
        <BkFlowRoomEnhancementButton
          enhancementKey={currentEnhancementKey}
          enhancementApiData={enhancementCardType[enhancementKey]}
          isEnhancementSelected={isEnhancementSelected}
          roomGroup={roomGroupKey}
          roomType={activeRoom[roomGroupKey][0][0].roomTypeCode}
          ratePlanCode={activeRoom[roomGroupKey][1][0].ratePlanCode}
        />
      </div>
    </div>
  )
}

export default BkFlowEnhancementsCardDefault



// WEBPACK FOOTER //
// ./src/components/enhancements/layouts/BkFlowEnhancementsCardDefault.js